import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Reusable alert component to warn users when no database record exists
 * for the current section/zone, preventing changes from being saved.
 * 
 * @param {Object} props - Component props
 * @param {string} props.sectionName - Name of the database section/table (e.g., "generalStation")
 * @param {number|string} props.zone - Current zone number or identifier
 * @param {string} [props.variant="warning"] - Bootstrap alert variant (warning, danger, etc.)
 * @param {string} [props.className] - Additional CSS classes
 * @param {React.ReactNode} [props.additionalMessage] - Optional additional message content
 * @returns {JSX.Element} Alert component warning about missing record
 */
const NoRecordFoundAlert = ({ 
  sectionName, 
  zone, 
  variant = "warning", 
  className = "",
  additionalMessage 
}) => {
  return (
    <div className={`p-3 ${className}`}>
      <Alert variant={variant}>
        <Alert.Heading>No Record Found</Alert.Heading>
        <p>
          No <strong>{sectionName}</strong> record exists for this project. If you believe this is an error, please try refreshing or contact support.
        </p>

        {additionalMessage && (
          <>
            <hr />
            {additionalMessage}
          </>
        )}
      </Alert>
    </div>
  );
};

export default NoRecordFoundAlert;